import React from 'react';
import { CheckIcon } from '@heroicons/react/24/outline';
import { SEMANTIC_HR_BI_EXPERIENCE } from '../../../../content/enterpriseMessaging';
import SemanticHRPbiGalleryVisual from './SemanticHRPbiGalleryVisual';
import SectionSurface from '../../shared/SectionSurface';

/** Report fatigue + in-app BI gallery + embedded Power BI: one story, one gallery capture. */
export default function BIReportExperience() {
  const { sprawl, gallery, embedded } = SEMANTIC_HR_BI_EXPERIENCE;

  const bullets = [
    sprawl.bullets[0],
    sprawl.bullets[1],
    gallery.bullets[0],
    gallery.bullets[1],
    embedded.bullets[0],
    embedded.bullets[2],
  ];

  return (
    <SectionSurface variant="subtle" decor="grid" bleed="both" flowTop flowBottom overlap>
      <section id="bi-gallery" className="scroll-mt-24 py-12 md:py-14">
        <div className="container-x">
          <div className="grid grid-cols-1 gap-8 lg:grid-cols-[minmax(0,0.95fr)_minmax(0,1.05fr)] lg:gap-10 lg:items-start">
            <div className="max-w-xl">
              <p className="eyebrow">{gallery.eyebrow}</p>
              <h2 className="mt-3 text-3xl font-semibold tracking-tight text-ink-900 sm:text-4xl">
                {sprawl.title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-ink-600">{gallery.body}</p>
              <p className="mt-4 text-sm leading-relaxed text-ink-500">{embedded.body}</p>
              <ul className="mt-6 space-y-2.5">
                {bullets.map((item) => (
                  <li key={item} className="flex items-start gap-2.5 text-sm text-ink-700 leading-relaxed">
                    <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-500" aria-hidden="true" />
                    {item}
                  </li>
                ))}
              </ul>
            </div>

            <div className="lg:sticky lg:top-28 w-full min-w-0 max-w-none">
              <SemanticHRPbiGalleryVisual className="w-full max-w-none" />
            </div>
          </div>
        </div>
      </section>
    </SectionSurface>
  );
}
